import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { combineReducers, createStore, compose, applyMiddleware } from 'redux';
import { sessionService } from 'redux-react-session';
import thunkMiddleware from 'redux-thunk';

import reducer from './actions'
import initialState from './initialState';

import './index.css';
import App from './App';

import registerServiceWorker from './registerServiceWorker';

const store = createStore(reducer, initialState, compose(applyMiddleware(thunkMiddleware)));
sessionService.initSessionService(store);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>, document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js